<script>
  import filters from '@/utils/filters'
  // import * as formats from '@/modules/formats.js'
  import * as api from '@/utils/api.js'
  const imgBaseUrl = 'https://media.eipl.org/site/images/uploads/'
  export default {
    name: 'ciAvailability',
    props: {
      categoriesById: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    data: () => ({
      endDate: null,
      isLoading: true,
      modalEndDate: false,
      modalStartDate: false,
      reservations: [],
      startDate: null,
      valid: true
    }),
    computed: {
      formErrors() {
        return {
          endDate: '',
          startDate: ''
        }
      }
    },
    methods: {
      allowedStart(val) {
        const startDate = val || '1980-01-01'
        const startTime = '00:00'
        const startDateTime = new Date(startDate + 'T' + startTime)
        // console.log('GET FILTERS, ENABLE ME')
        const events = this.reservations.filter(e => {
          return !filters.testRangeOverlap(
            e.start_date,
            e.end_date,
            startDateTime,
            startDateTime,
            // this.allDay
            // ci.reservation_buffer
            1
          )
        })
        return events.length >= this.reservations.length
        return true
        // return val && true

        // const endDate = this.endDate || '3000-01-01'
        // const endTime = this.endTime || '00:00'
        // const endDateTime = new Date(endDate + 'T' + endTime)
        // if (this.ciSelected) {
        //   const ci = { ...this.ciSelected }
        //   events = this.events.filter(e => {
        //     if (e.item_id === ci.id) {
        //       return (
        //         !filters.testRangeOverlap(
        //           e.start_date,
        //           e.end_date,
        //           startDateTime,
        //           startDateTime,
        //           // this.allDay
        //           // ci.reservation_buffer
        //           1
        //         ) || e.id == this.id
        //       )
        //     } else {
        //       return true
        //     }
        //   })
        //   return (
        //     events.length >= this.events.length &&
        //     startDateTime.getTime() < endDateTime.getTime()
        //   )
        // } else {
        //   return true
        // }
      },
      thumbnailSrc() {
        return `${imgBaseUrl}${this.item?.image_data?.src || this.item?.image_data || ''}`
        // return 'https://www.eipl.org/newsite/statichttps://media.eipl.org/site/images/generic/music_cd_art_not_found.png'
      }
    },
    async mounted() {
      // todo: Finish transitioning
      // const reservations = await api.get(`lot/item/reservations/${this.item.id}`)
      // old subdomain while transitioning
      // const reservations = await api.get(`https://old.eipl.org/api/Org/lotReservations/${this.item.id}`)
      const reservations = await api.get(`https://www.eipl.org/api/Org/lotReservations/${this.item.id}`, undefined, false)
      this.reservations = reservations?.length ? reservations : []
      this.isLoading = false
    }
  }
</script>
<template>
  <v-card>
    <v-card-title class="text-h6 justify-center primary--text"> CHECK AVAILABILITY </v-card-title>
    <v-card-text class="pb-0">
      <v-row dense align="center" justify="start">
        <v-col cols="12" class="text-left">
          <p class="text-body-2 primary--text font-weight-bold mb-2">Use the calendar below to find days this item is available for reservation.</p>
          <p class="text-body-2 primary--text font-weight-bold">Dark, black dates signify availability.</p>
        </v-col>
        <v-col cols="2" align-self="center" class="d-flex justify-center mt-2">
          <v-img contain height="70" :src="thumbnailSrc()" class="pa-0"></v-img>
        </v-col>
        <v-col cols="8" class="ml-3">
          <v-row dense class="display-flex align-center justify-start">
            <!-- <a v-html="item.name" class="font-weight-medium title"></a> -->
            <span class="font-weight-medium title primary--text">
              {{ item.name }}
            </span>
          </v-row>
          <v-row dense class="display-flex flex-column align-start justify-start">
            <div>
              <v-avatar size="10" :color="categoriesById[item.category].color" class="mr-1"></v-avatar>
              <p v-html="categoriesById[item.category].name" class="font-italic subheading text-capitalize" style="display: inline"></p>
            </div>
            <p>{{ `Reservation period: ${item.reservation_length} Days` }}</p>
          </v-row>
        </v-col>
      </v-row>
      <form>
        <v-row align="center" justify="center" dense>
          <v-col cols="12" class="text-center">
            <v-progress-circular v-if="isLoading" color="primary" indeterminate></v-progress-circular>
            <v-date-picker v-else :allowed-dates="allowedStart" full-width no-title readonly class="mt-2"></v-date-picker>
          </v-col>
        </v-row>
      </form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="$emit('close')"> Close </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss" scoped></style>
